import * as React from 'react';
import { cn } from '../../lib/shadcn-utils';

const Table = React.forwardRef(({ as: Comp = 'div', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
Table.displayName = 'Table';

const TableHeader = React.forwardRef(({ as: Comp = 'header', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
TableHeader.displayName = 'TableHeader';

const TableBody = React.forwardRef(({ as: Comp = null, className, children, ...props }, ref) => {
  if (!Comp) {
    return <>{children}</>;
  }
  return (
    <Comp ref={ref} className={cn(className)} {...props}>
      {children}
    </Comp>
  );
});
TableBody.displayName = 'TableBody';

const TableFooter = React.forwardRef(({ as: Comp = 'footer', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
TableFooter.displayName = 'TableFooter';

const TableRow = React.forwardRef(({ as: Comp = 'div', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
TableRow.displayName = 'TableRow';

const TableHead = React.forwardRef(({ as: Comp = 'span', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
TableHead.displayName = 'TableHead';

const TableCell = React.forwardRef(({ as: Comp = 'span', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
TableCell.displayName = 'TableCell';

const TableCaption = React.forwardRef(({ as: Comp = 'p', className, ...props }, ref) => (
  <Comp ref={ref} className={cn(className)} {...props} />
));
TableCaption.displayName = 'TableCaption';

export { Table, TableHeader, TableBody, TableFooter, TableHead, TableRow, TableCell, TableCaption };
